export const URL_BASE = '/api'

export function fromJson(model, object) {
    for (var name in model) {
        if (object.hasOwnProperty(name)) {
            model[name] = object[name]
        }
    }

    return model
}

export const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export function years(startYear, endYear = null) {

    var currentYear = endYear ? endYear : new Date().getFullYear() + 1, years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
        years.push(startYear++);
    }

    years.sort(function (a, b) {
        return b - a
    })
    return years;
}

export  function  randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
